import { ThemeValue } from "grommet";

export const theme: ThemeValue = {
  global: {
    font: {
      family: 'Nunito',
      color: {
        "dark": "#B3B3B3",
        "light": '#323232'
      },
    },
    colors: {
      background: {
        "dark": '#323232',
        "light": "#ffffff"
      },
      border: '#565654', // dark grey
      blue1: '#2aaee9',
      spinner: '#2aaee9',
      yellow1: '#FFF7AD',
      grey1: "#B3B3B3",
      green1: '#a0ffa0'
    },
    focus: {
      border: {
        color: "transparent",
      },
    },
  }
}
